// Layout.js
import React from "react";
import CAR from "../Images/customer/policy-car.svg";
import TWO from "../Images/customer/policy-bike.svg";
import HLT from "../Images/customer/policy-health.svg";
import INV from "../Images/customer/policy-investment.svg";
import PCV from "../Images/customer/policy-pcv.webp";
import GCV from "../Images/customer/policy-gcv.webp";
import TAXI from "../Images/customer/policy-taxi.webp";
import LIF from "../Images/customer/policy-life.svg";
import HOME from "../Images/customer/home.webp";
import PET from "../Images/customer/pet.webp";
import PI from "../Images/customer/Professional-Indemnity.webp";

// Map codes to images
const logoMap = {
    CAR: CAR,
    TWO: TWO,
    HLT: HLT,
    INV: INV,
    GCV: GCV,
    PCV: PCV,
    TAXI: TAXI,
    LIF: LIF,
    HOME: HOME,
    PET: PET,
    PI: PI,
    PrivateCar: CAR,
    TwoWheeler: TWO,
};

// Map codes to display labels
const labelMap = {
    CAR: "Car",
    TWO: "Bike",
    HLT: "Health",
    INV: "Investment",
    GCV: "Goods Commercial Vehicle",
    PCV: "Passenger Commercial Vehicle",
    TAXI: "Taxi",
    LIF: "Life",
    HOME: "Home",
    PET: "Pet",
    PI: "Professional Indemnity",
    PrivateCar: "Car",
    TwoWheeler: "Bike",
};

const ProductLogo = ({ item }) => {
    const key = item.vehicleType && logoMap[item.vehicleType]
        ? item.vehicleType
        : item.PolicyType && logoMap[item.PolicyType]
            ? item.PolicyType
            : "CAR"; // default fallback

    const logoSrc = logoMap[key];
    const label = labelMap[key] || "Car";

    return (
        <>
            <img alt={label} src={logoSrc} />
            <p>{label}</p>
        </>
    );
};

export default ProductLogo;
